export default __webpack_public_path__ + "static/media/pinterest.a56ee8fd.svg";